import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import { CompanyReservationFlowV2Component } from "../company-reservation-flow-v2/company-reservation-flow-v2.component";

@Component({
  selector: "app-company-reservation",
  templateUrl: "./company-reservation.component.html",
  styleUrls: ["./company-reservation.component.css"],
})
export class CompanyReservationComponent implements OnInit {
  @ViewChild("reservationFlow") reservationFlow: CompanyReservationFlowV2Component;

  constructor() {}

  ngOnInit(): void {}

  @HostListener("window:beforeunload")
  public canDeactivate(): Observable<boolean> | boolean {
    return this.reservationFlow.canDeactivate();
  }
}
